const BASE_URL_REGEXP =
  '(https?:\\/\\/)?(([A-Za-zА-Яа-яЁё0-9@][A-Za-zА-Яа-яЁё0-9@\\-\\_\\.]*[A-Za-zА-Яа-яЁё0-9@])(\\/([A-Za-zА-Яа-я0-9@\\-\\_#%&?+\\/\\.=;:~]*[^\\.\\,;\\(\\)\\?<\\&\\s:])?)?)';

export const STRICT_URL_REGEXP = new RegExp(`^${BASE_URL_REGEXP}$`, 'gi');

export const SUBSTR_URL_REGEXP = new RegExp(BASE_URL_REGEXP, 'gi');

export const SUBSTR_EMAIL_REGEXP = /[a-zA-Z\-_\.0-9]+@[a-zA-Z\-_0-9]+\.[a-zA-Z\-_\.0-9]+[a-zA-Z\-_0-9]+/g;
